// extracted by mini-css-extract-plugin
export default {"title":"Teams_title__CkEnE","tableContainer":"Teams_tableContainer__4B-en"};